import { render, staticRenderFns } from "./text-underline2.vue?vue&type=template&id=9d477500&scoped=true&"
var script = {}
import style0 from "./text-underline2.vue?vue&type=style&index=0&id=9d477500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d477500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d477500')) {
      api.createRecord('9d477500', component.options)
    } else {
      api.reload('9d477500', component.options)
    }
    module.hot.accept("./text-underline2.vue?vue&type=template&id=9d477500&scoped=true&", function () {
      api.rerender('9d477500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-underline2.vue"
export default component.exports